import React from "react";

export function EmailColumn({ value }){
	return <a href={`mailto://${value}`}>{value}</a>;
}

const EmailCell = {
	key: "email",
	name: "Primary Contact",
	formatter: EmailColumn,
	resizable:true,
	sortable:true,
};

export default EmailCell;
